import { Component, ElementRef, ViewChild, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ProductHomepagesConfig, WINDOW } from '@frontend/vanilla/core';

@Component({
    selector: 'bs-betslip-panicslider',
    templateUrl: './betslip-panicslider.component.html',
    standalone: false,
})
export class BetslipPanicsliderComponent {
    swipeEnabled = true;
    swipeStartThreshold = 0;
    swipeEndThreshold: number;
    @ViewChild('panicSlider') container: ElementRef;
    private readonly _window = inject(WINDOW);

    constructor(
        public sitecore: Sitecore,
        private productHomepagesConfig: ProductHomepagesConfig,
    ) {}

    onPanStart(): void {
        this.swipeEndThreshold = this.container.nativeElement.offsetWidth * 0.75;
    }

    onPanMove(event: HammerInput): void {
        if (event.deltaX >= this.swipeEndThreshold) {
            this._window.location.href = this.productHomepagesConfig.portal + this.sitecore.panicButtonMessages.PanicButtonPath;
        }
    }
}
